import React from 'react'
import { useSelector } from 'react-redux'
import s from './GeoentityContactInfoButtons.less'
import GeoentityWebsiteButton from './GeoentityWebsiteButton'
import GeoentityEmailButton from './GeoentityEmailButton'
import GeoentityPhoneButton from './GeoentityPhoneButton'
import { withEmptyFallbackErrorBoundary } from '../../error/EmptyFallbackErrorBoundary'
import { useSelectorEmptiness } from '../../utils/react-redux'
import { selectWebsiteUrl, selectPhone, selectEmail } from './contactInfo.selectors'
import { selectIsTransactionalHotelGeoentity } from '../../../store/geoentity/geoentity.selectors'
import GeoentityShareButton from './GeoentityShareButton'
import { GeoentityFavoriteButton } from '../../UserAccount/connected/userFavorites/FavoriteButton'
import { selectShouldDisplayFavoriteButtonForCurrentGeoentity } from '../../../store/userAccount/userAccount.selectors'

export default withEmptyFallbackErrorBoundary(function GeoentityContactInfoButtons() {
  const hasWebsite = useSelectorEmptiness(selectWebsiteUrl)
  const hasPhone = useSelectorEmptiness(selectPhone)
  const hasEmail = useSelectorEmptiness(selectEmail)
  const shouldDisplayFavoriteButton = useSelector(selectShouldDisplayFavoriteButtonForCurrentGeoentity)

  const isTransacHotel = useSelector(selectIsTransactionalHotelGeoentity)

  return !isTransacHotel ? (
    <BaseGeoentityContactInfoButtons {...{ hasWebsite, hasPhone, hasEmail, shouldDisplayFavoriteButton }} />
  ) : (
    <BaseGeoentityContactInfoButtons {...{ hasWebsite, shouldDisplayFavoriteButton }} />
  )
})

export const BaseGeoentityContactInfoButtons = ({ hasWebsite, hasEmail, hasPhone, shouldDisplayFavoriteButton }) => {
  return (
    <div className={s.root}>
      {hasWebsite && (
        <div>
          <GeoentityWebsiteButton />
        </div>
      )}
      {hasEmail && (
        <div>
          <GeoentityEmailButton />
        </div>
      )}
      {hasPhone && (
        <div>
          <GeoentityPhoneButton />
        </div>
      )}
      <div>
        <GeoentityShareButton />
      </div>
      {shouldDisplayFavoriteButton && (
        <div>
          <GeoentityFavoriteButton />
        </div>
      )}
    </div>
  )
}
